//moved to cache.jsp
//document.writeln('<link rel="stylesheet" type="text/css" href="scripts/jquery/select2-4.0.2-rc.1/css/select2.min.css" />');

if (Config.languageISOCode == 'zh') {
  document.write('<script type="text/javascript" src="scripts/jquery/select2-4.0.2-rc.1/js/i18n/zh-CN.js"></script>');
}
else if (Config.languageISOCode != 'en') {
  document.write('<script type="text/javascript" src="scripts/jquery/select2-4.0.2-rc.1/js/i18n/'+Config.languageISOCode+'.js"></script>');
}

jQuery(document).ready(function() {

  $(".select2").select2({
    positionDropdown: false,
    language: Config.languageISOCode
  });

});